// extracted by mini-css-extract-plugin
module.exports = {"d2xDetailE":"E_d2xDetailE__3x54_"};